import { useEffect, useRef, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import BotaoFechar from "../BotaoFechar/BotaoFechar";
import "./ModalSistemas.css";
import BotaoPadrao from "../BotaoPadrao/BotaoPadrao";

const ModalSistemas = ({ 
  aberto, 
  onClose, 
  titulo, 
  subtitulo, 
  sistemas,
  children,
  onRetornar,
  animacaoExpandir = false,
  etapaModal,
  alturaEtapa, // altura fixa em rem só na listagem
  tamanhoEtapa, // largura fixa em rem, tem prioridade sobre largura padrão
  className,
  overlayClassName,
  onConfirmar,
  onCancelar,
  txtBtnConfirmar = "Confirmar"
}) => {
  const [visivel, setVisivel] = useState(aberto);
  const [animando, setAnimando] = useState(false);
  const timeoutRef = useRef();
  const animacaoRef = useRef();
  const containerRef = useRef();
  const [animandoAltura, setAnimandoAltura] = useState(false);
  const [conteudoVisivel, setConteudoVisivel] = useState(children);
  const [etapaAnterior, setEtapaAnterior] = useState(etapaModal);

  useEffect(() => {
    // Limpa estilos de animação de altura para não sobrescrever transições CSS padrão
    if (containerRef.current) {
      containerRef.current.style.height = '';
      containerRef.current.style.transition = '';
      setAnimandoAltura(false);
    }
    if (aberto) {
      setVisivel(true);
      animacaoRef.current = setTimeout(() => setAnimando(true), 10);
    } else {
      setAnimando(false);
      timeoutRef.current = setTimeout(() => setVisivel(false), 300);
    }
    return () => {
      clearTimeout(timeoutRef.current);
      clearTimeout(animacaoRef.current);
    };
  }, [aberto]);

  useEffect(() => {
    if (etapaModal === etapaAnterior) return;
    if (!containerRef.current) return;
    const node = containerRef.current;
    const alturaAntiga = node.offsetHeight;
    node.style.height = alturaAntiga + "px";
    setAnimandoAltura(true);
    setConteudoVisivel(children);
    // eslint-disable-next-line no-unused-expressions
    node.offsetHeight;
    // Atualiza nova altura após renderização do conteúdo
    setTimeout(() => {
      // Medir em próximo frame após DOM update
      requestAnimationFrame(() => {
        const alturaNova = node.scrollHeight;
        node.style.height = alturaNova + "px";
      });
      const handle = (e) => {
        if (e.propertyName === 'height') {
          node.removeEventListener('transitionend', handle);
          node.style.height = '';
          setAnimandoAltura(false);
        }
      };
      node.addEventListener("transitionend", handle);
    }, 0);
    setEtapaAnterior(etapaModal);
  }, [etapaModal]);

  useEffect(() => {
    if (etapaModal === etapaAnterior) {
      setConteudoVisivel(children);
    }
  }, [children]);

  if (!visivel && !aberto) return null;

  const overlayBase = overlayClassName || 'modal-sistemas-overlay';
  const overlayClass =
    visivel && animando ? `${overlayBase} modal-sistemas-aberto ${className || ''}` : `${overlayBase} ${className || ''}`;

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  const containerClass = [
    "modal-sistemas-container",
    animacaoExpandir ? "modal-sistemas-expandir" : "",
    animandoAltura ? "modal-sistemas-altura-animando" : ""
  ].filter(Boolean).join(" ");

  // monta style do container: overflow durante animação, height fixa na etapa 'listar', width se tamanhoEtapa
  const styleContainer = {
    ...(animandoAltura ? { overflow: 'hidden' } : {}),
    ...(etapaModal === 'listar' && alturaEtapa ? { height: `${alturaEtapa}rem` } : {}),
    ...(tamanhoEtapa ? { width: `${tamanhoEtapa}rem` } : {})
  };

  return (
    <div className={overlayClass} onClick={handleOverlayClick}>
      <div
        className={containerClass}
        ref={containerRef}
        style={styleContainer}
      >
        <div className={`modal-sistemas-header${onRetornar ? ' com-seta' : ''}`}>
          <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
            {onRetornar && (
              <button
                className="modal-sistemas-retornar"
                onClick={onRetornar}
                aria-label="Voltar"
                type="button"
              >
                <IoIosArrowBack size={26} />
              </button>
            )}
            <span className="modal-sistemas-titulo">{titulo}</span>
          </div>
          <button className="modal-sistemas-fechar" onClick={onClose} aria-label="Fechar">
            <BotaoFechar />
          </button>
        </div>
        <span className="modal-sistemas-subtitulo">{subtitulo}</span>
        <div className="modal-sistemas-conteudo">{conteudoVisivel}</div>
        <div className="modal-sistemas-rodape"> 
            {onCancelar && (
              <BotaoPadrao
                texto="Cancelar"
                cancelar={true}
                aoClicar={onCancelar}
              />
            )}
            {onConfirmar && (
              <BotaoPadrao
                texto={txtBtnConfirmar}
                aoClicar={onConfirmar}
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default ModalSistemas;
